var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgE2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 278,
    height: 188,
    viewBox: "0 0 278 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(-407.5 -2001)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "in_some_provinces",
    "data-name": "in some provinces",
    transform: "translate(546.5 2186)",
    fill: "#1d1d1d",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -62.888,
    y: 0
  }, "in some provinces")), /*#__PURE__*/React.createElement("text", {
    id: "Coercive_control_is_a_",
    "data-name": "Coercive control is a ",
    transform: "translate(546.5 2025)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -97.28,
    y: 0
  }, "COERCIVE CONTROL IS A ")), /*#__PURE__*/React.createElement("text", {
    id: "criminal_offence",
    "data-name": "criminal offence",
    transform: "translate(546.5 2095)",
    fill: "#9c3230",
    fontSize: 77,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.06em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -138.754,
    y: 0
  }, "CRIMINAL"), /*#__PURE__*/React.createElement("tspan", {
    x: -119.812,
    y: 70
  }, "OFFENCE")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE2);
export default __webpack_public_path__ + "static/media/e2.29c4860a0adc6b0eabfdc29a805bf7f0.svg";
export { ForwardRef as ReactComponent };